import { useState, useEffect, useRef } from "react";
import {
  InputLabel,
  TextField,
  Typography,
  FormHelperText,
  MenuItem,
  Checkbox,
} from "@mui/material";
import { Grid } from "@mui/material";
import DatePicker from "react-date-picker";
import "react-date-picker/dist/DatePicker.css";
import "react-calendar/dist/Calendar.css";
import styles from "./style.module.css";
import validationSchema from "./validation";
import FrontendApi from "../../../config/apis/frontend";
import Form from "../../../components/forms/Forms";
import { styled } from "@mui/material/styles";
import RadioGroup, { useRadioGroup } from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Radio from "@mui/material/Radio";
import { ToastContainer } from "react-toastify";
import StudentApi from "../../../config/apis/student";
import { api, resolveUrl } from "../../../config/apis";
import moment from "moment";
import { GetUserId } from "../../../helper/helperFunction";

export default function PostAssessmentForm(props) {
  const [formSuccess, setFormSuccess] = useState(false);
  const studentId = GetUserId();

  const intaialFormData = {
    student_id: "",
    cohort: "",
    section: "",
    registration_date: "",
    shift_days: "",
    shift_time: "",
    household_items: [],
    smartphone: "",
    laptopdesktop: "",
    currently_employed: "",
    position: "",
    salary: "",
    employer_name: "",
    code_girls_training_related_work: "",
    code_girls_training_related_work_other: "",
    interested_in_partner_opportunity: "",
    interested_in_partner_opportunity_other: "",
    opportunity_preference: "",
    interested_in_advanced_phase: "",
    interested_in_advanced_phase_other: "",
    interested_in_events: "",
    interested_in_events_other: "",
    prefer_freelancing: "",
    prefer_freelancing_other: "",
    // New fields for post-assessment
    training_objective_achieved: "",
    recommend_consulnet: "",
    training_impact_personal_life: [],
    post_training_activity: "",
    post_training_activity_other: "",
    future_plans: "",
    employment_status: "",
    unemployment_reasons: [],
    number_of_jobs: null,
    employment_relevance: "",
    total_experience_years: null,
    tech_experience_years: null,
    career_without_training: "",
    pay_better_than_before: "",
    pay_better_reason: "",
    freelancing_platforms: "",
    freelancing_projects: "",
    freelancing_income: "",
    freelancing_technologies: "",
    freelancing_help_from_training: "",
    business_name: "",
    business_nature: "",
    business_sales_platforms: "",
    business_tech_enabled: "",
    business_duration: null,
    business_monthly_revenue: "",
    engagement_feature_journey: "",
    engagement_community_roles: [],
  };
  const [formData, setFormData] = useState(intaialFormData);
  // const inputRef = useRef(null);

  useEffect(() => {
    if (props.setFormSuccess) {
      props.setFormSuccess(formSuccess);
    }
  }, [formSuccess]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await api.get(StudentApi.GET_STUDENT_DATA);
        const {
          CohortName,
          RegistrationDate,
          SectionName,
          ShiftDays,
          ShiftTime,
          StudentID,
        } = res.data.data;

        setFormData((prevData) => ({
          ...prevData,
          student_id: StudentID,
          cohort: CohortName,
          section: SectionName,
          registration_date: RegistrationDate,
          shift_days: ShiftDays,
          shift_time: ShiftTime,
        }));
      } catch (error) {
        console.error("Error fetching general data:", error);
      }
    };
    if (studentId) {
      fetchData();
    }
  }, []);

  useEffect(() => {
    const fetchEditData = async () => {
      try {
        const res = await api.get(
          resolveUrl(StudentApi.GET_POST_ASSESSMENT_FORM, studentId)
        );
        
        const data = res.data.data;
        
        // Ensure array fields are properly formatted
        const processedData = {
          ...data,
          household_items: Array.isArray(data.household_items) 
            ? data.household_items.map((item) => item.replace(/^\s+/g, ""))
            : [],
          training_impact_personal_life: Array.isArray(data.training_impact_personal_life)
            ? data.training_impact_personal_life
            : [],
          unemployment_reasons: Array.isArray(data.unemployment_reasons)
            ? data.unemployment_reasons
            : [],
          engagement_community_roles: Array.isArray(data.engagement_community_roles)
            ? data.engagement_community_roles
            : [],
        };

        setFormData((prevData) => ({
          ...prevData,
          ...processedData,
        }));
      } catch (error) {
        console.error("Error fetching edit data:", error);
      }
    };
    if (studentId) {
      fetchEditData();
    }
  }, [studentId]);

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));

    setErrors((prevErrors) => ({
      ...prevErrors,
      [name]: undefined,
    }));
  };
  
  const handleInputChangeNumber = (event) => {
    const { name, value } = event.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value ? Number(value) : null,
    }));

    setErrors((prevErrors) => ({
      ...prevErrors,
      [name]: undefined,
    }));
  };

  const [errors, setErrors] = useState({});

  const customValidation = async () => {
    try {
      await validationSchema.validate(formData, { abortEarly: false });
      setErrors({});
      return true;
    } catch (error) {
      const newErrors = {};
      if (error.inner) {
        error.inner.forEach((validationError) => {
          newErrors[validationError.path] = validationError.message;
        });
        console.error("Validation Errors:", newErrors);
        console.error("Form Data at validation:", formData);
      } else {
        console.error(error);
      }

      setErrors(newErrors);
      return false;
    }
  };

  const StyledFormControlLabel = styled((props) => (
    <FormControlLabel {...props} />
  ))(({ theme, checked }) => ({
    ".MuiFormControlLabel-label": checked && {
      color: theme.palette.primary.main,
    },
  }));

  function MyFormControlLabel(props) {
    const radioGroup = useRadioGroup();

    let checked = false;

    if (radioGroup) {
      checked = radioGroup.value === props.value;
    }

    return <StyledFormControlLabel checked={checked} {...props} />;
  }

  // Generic checkbox handler for all checkbox groups
  const handleCheckboxChange = (fieldName, item) => {
    setFormData((prevFormData) => {
      const currentArray = prevFormData[fieldName] || [];
      const updatedArray = currentArray.includes(item)
        ? currentArray.filter((selectedItem) => selectedItem !== item)
        : [...currentArray, item];

      return {
        ...prevFormData,
        [fieldName]: updatedArray,
      };
    });
    
    // Clear errors for this field
    setErrors((prevErrors) => ({
      ...prevErrors,
      [fieldName]: undefined,
    }));
  };

  const handleHouseholdGroupChange = (event) => {
    setFormData({
      ...formData,
      household_items: [event.target.value],
    });
  };

  return (
    <>
      <div
        className={`container global-user ${styles.preAssessmentFormContainer}`}
      >
        <Typography variant="h1" className="main-heading">
          Post Assessment Form
        </Typography>
        <Grid container className={`page-container ${styles.addStudent}`}>
          <Grid item xs={12} className="inner-container">
            <Form
              successPath="/admin/post-assessment"
              submitUrl={StudentApi.POST_ASSESSMENT_FORM}
              formData={formData}
              validate={customValidation}
              setFormSuccess={setFormSuccess}
              editId={studentId}
              saveText="Submit"
            >
              <Grid container justifyContent={"space-between"}>
                <Grid item lg={12}>
                  <Grid container spacing={2} marginBottom={2}>
                    <Grid
                      item
                      xl={4}
                      lg={6}
                      xs={12}
                      container
                      sx={{ mb: 1, alignItems: "center" }}
                    >
                      <Grid item xs={12} sx={{ mb: 2 }}>
                        <InputLabel
                          xs={{
                            textAlign: "left",
                            whiteSpace: "normal",
                            lineHeight: "18px",
                          }}
                        >
                          Registration Number/Student ID*
                        </InputLabel>
                      </Grid>
                      <Grid item xs={12}>
                        <TextField
                          fullWidth
                          sx={{ backgroundColor: "#F4F4F4" }}
                          name="student_id"
                          variant="outlined"
                          value={formData.student_id}
                          onChange={(e) => handleInputChangeNumber(e)}
                          error={errors.student_id !== undefined}
                          helperText={errors.student_id}
                          type="number"
                          disabled
                        />
                      </Grid>
                    </Grid>

                    <Grid
                      item
                      xl={4}
                      lg={6}
                      xs={12}
                      container
                      sx={{ mb: 1, alignItems: "center" }}
                    >
                      <Grid item xs={12} sx={{ mb: 2 }}>
                        <InputLabel sx={{ textAlign: "left" }}>
                          Cohort*
                        </InputLabel>
                      </Grid>
                      <Grid item xs={12}>
                        <TextField
                          fullWidth
                          sx={{ backgroundColor: "#F4F4F4" }}
                          name="cohort"
                          variant="outlined"
                          placeholder="Enter Cohort"
                          value={formData.cohort}
                          onChange={handleInputChange}
                          error={errors.cohort !== undefined}
                          helperText={errors.cohort}
                          disabled
                        />
                      </Grid>
                    </Grid>

                    <Grid
                      item
                      xl={4}
                      lg={6}
                      xs={12}
                      container
                      sx={{ mb: 1, alignItems: "center" }}
                    >
                      <Grid item xs={12} sx={{ mb: 2 }}>
                        <InputLabel sx={{ textAlign: "left" }}>
                          Cohort Section*
                        </InputLabel>
                      </Grid>
                      <Grid item xs={12}>
                        <TextField
                          sx={{ backgroundColor: "#F4F4F4" }}
                          fullWidth
                          name="section"
                          variant="outlined"
                          placeholder="Enter Cohort Section"
                          value={formData.section}
                          onChange={handleInputChange}
                          error={errors.section !== undefined}
                          helperText={errors.section}
                          disabled
                        />
                      </Grid>
                    </Grid>

                    <Grid
                      item
                      xl={4}
                      lg={6}
                      xs={12}
                      container
                      sx={{ mb: 1, alignItems: "center" }}
                    >
                      <Grid item xl={12} sx={{ mb: 2 }}>
                        <InputLabel> Registration Date* </InputLabel>
                      </Grid>
                      <Grid item xs={12} className="bg_field">
                        <DatePicker
                          calendarAriaLabel="Toggle calendar"
                          clearAriaLabel="Clear value"
                          dayAriaLabel="Day"
                          monthAriaLabel="Month"
                          nativeInputAriaLabel="Date"
                          disabled
                          onChange={(date) =>
                            setFormData((prevFormData) => ({
                              ...prevFormData,
                              registration_date: date
                                ? moment(date).format("YYYY-MM-DD")
                                : null,
                            }))
                          }
                          value={
                            formData.registration_date
                              ? new Date(formData.registration_date)
                              : null
                          }
                          yearAriaLabel="Year"
                        />
                        {errors.registration_date && (
                          <FormHelperText error>
                            {errors.registration_date}
                          </FormHelperText>
                        )}
                      </Grid>
                    </Grid>

                    <Grid
                      item
                      xl={4}
                      lg={6}
                      xs={12}
                      container
                      sx={{ mb: 1, alignItems: "center" }}
                    >
                      <Grid item xl={3} sx={{ mb: 2 }}>
                        <InputLabel> Shift Day* </InputLabel>
                      </Grid>
                      <Grid item xs={12}>
                        <TextField
                          fullWidth
                          sx={{ backgroundColor: "#F4F4F4" }}
                          name="shift_days"
                          variant="outlined"
                          placeholder="Enter Cohort Section"
                          value={formData.shift_days}
                          onChange={handleInputChange}
                          error={errors.shift_days !== undefined}
                          helperText={errors.shift_days}
                          disabled
                        />
                      </Grid>
                    </Grid>

                    <Grid
                      item
                      xl={4}
                      lg={6}
                      xs={12}
                      container
                      sx={{ mb: 1, alignItems: "center" }}
                    >
                      <Grid item xl={3} sx={{ mb: 2 }}>
                        <InputLabel> Shift Time* </InputLabel>
                      </Grid>
                      <Grid item xs={12}>
                        <TextField
                          fullWidth
                          sx={{ backgroundColor: "#F4F4F4" }}
                          name="shift_time"
                          variant="outlined"
                          placeholder="Enter Cohort Section"
                          value={formData.shift_time}
                          onChange={handleInputChange}
                          error={errors.shift_time !== undefined}
                          helperText={errors.shift_time}
                          disabled
                        />
                      </Grid>
                    </Grid>
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    container
                    sx={{ mb: 3, alignItems: "center" }}
                  >
                    <Grid item xs={12} sx={{ mb: 2 }}>
                      <InputLabel
                        sx={{
                          textAlign: "left",
                          whiteSpace: "normal",
                          lineHeight: "18px",
                        }}
                      >
                        Which Of The Following Do You Have In Your Household?*
                      </InputLabel>
                    </Grid>
                    <Grid item xs={12}>
                      {[
                        "A Smartphone",
                        "A Tablet",
                        "A Desktop",
                        "A Laptop",
                        "Broadband Connection",
                      ].map((item, index) => {
                        return (
                          <FormControlLabel
                            key={index}
                            control={
                              <Checkbox
                                checked={formData.household_items.includes(
                                  item
                                )}
                                onChange={() => handleCheckboxChange('household_items', item)}
                                name="household_items"
                              />
                            }
                            label={item}
                          />
                        );
                      })}
                    </Grid>
                    {errors.household_items && (
                      <FormHelperText error>
                        {errors.household_items}
                      </FormHelperText>
                    )}
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    container
                    sx={{ mb: 3, alignItems: "center" }}
                  >
                    <Grid item xs={12} sx={{ mb: 2 }}>
                      <InputLabel
                        sx={{
                          textAlign: "left",
                          whiteSpace: "normal",
                          lineHeight: "18px",
                        }}
                      >
                        Do You Own A Smartphone?*
                      </InputLabel>
                    </Grid>
                    <Grid item xs={12}>
                      <RadioGroup
                        row
                        name="smartphone"
                        defaultValue="first"
                        onChange={handleInputChange}
                        value={formData.smartphone}
                      >
                        <MyFormControlLabel
                          value="Yes"
                          label="Yes"
                          control={<Radio />}
                        />
                        <MyFormControlLabel
                          value="No"
                          label="No"
                          control={<Radio />}
                        />
                      </RadioGroup>
                    </Grid>
                    {errors.smartphone && (
                      <FormHelperText error>{errors.smartphone}</FormHelperText>
                    )}
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    container
                    sx={{ mb: 3, alignItems: "center" }}
                  >
                    <Grid item xs={12} sx={{ mb: 2 }}>
                      <InputLabel
                        sx={{
                          textAlign: "left",
                          whiteSpace: "normal",
                          lineHeight: "18px",
                        }}
                      >
                        Do You Own A Laptop/Desktop?*
                      </InputLabel>
                    </Grid>
                    <Grid item xs={12}>
                      <RadioGroup
                        row
                        name="laptopdesktop"
                        defaultValue="first"
                        value={formData.laptopdesktop}
                        onChange={handleInputChange}
                      >
                        <MyFormControlLabel
                          value="Yes"
                          label="Yes"
                          control={<Radio />}
                        />
                        <MyFormControlLabel
                          value="No"
                          label="No"
                          control={<Radio />}
                        />
                      </RadioGroup>
                    </Grid>
                    {errors.laptopdesktop && (
                      <FormHelperText error>
                        {errors.laptopdesktop}
                      </FormHelperText>
                    )}
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    container
                    sx={{ mb: 3, alignItems: "center" }}
                  >
                    <Grid item xs={12} sx={{ mb: 2 }}>
                      <InputLabel
                        sx={{
                          textAlign: "left",
                          whiteSpace: "normal",
                          lineHeight: "18px",
                        }}
                      >
                        Are You Currently Employed?*
                      </InputLabel>
                    </Grid>
                    <Grid item xs={12}>
                      <RadioGroup
                        row
                        name="currently_employed"
                        defaultValue="first"
                        value={formData.currently_employed}
                        onChange={handleInputChange}
                      >
                        <MyFormControlLabel
                          value="Yes"
                          label="Yes"
                          control={<Radio />}
                        />
                        <MyFormControlLabel
                          value="No"
                          label="No"
                          control={<Radio />}
                        />
                      </RadioGroup>
                    </Grid>
                    {errors.currently_employed && (
                      <FormHelperText error>
                        {errors.currently_employed}
                      </FormHelperText>
                    )}
                  </Grid>
                  {formData.currently_employed === "Yes" && (
                    <>
                      <Grid container spacing={2}>
                        <Grid
                          item
                          xl={4}
                          lg={6}
                          xs={12}
                          container
                          sx={{ mb: 1, alignItems: "center" }}
                        >
                          <Grid item xs={12} sx={{ mb: 2 }}>
                            <InputLabel
                              sx={{
                                textAlign: "left",
                                whiteSpace: "normal",
                                lineHeight: "18px",
                              }}
                            >
                              Please Add The Position*
                            </InputLabel>
                          </Grid>
                          <Grid item xs={12}>
                            <TextField
                              fullWidth
                              name="position"
                              variant="outlined"
                              placeholder="Please Add The Position"
                              value={formData.position}
                              onChange={handleInputChange}
                              error={errors.position !== undefined}
                              helperText={errors.position}
                            />
                          </Grid>
                        </Grid>

                        <Grid
                          item
                          xl={4}
                          lg={6}
                          xs={12}
                          container
                          sx={{ mb: 1, alignItems: "center" }}
                        >
                          <Grid item xs={12} sx={{ mb: 2 }}>
                            <InputLabel
                              sx={{
                                textAlign: "left",
                                whiteSpace: "normal",
                                lineHeight: "18px",
                              }}
                            >
                              What Is Your Salary?*
                            </InputLabel>
                          </Grid>
                          <Grid item xs={12}>
                            <TextField
                              fullWidth
                              name="salary"
                              variant="outlined"
                              placeholder="What Is Your Salary?"
                              value={formData.salary}
                              onChange={handleInputChange}
                              error={errors.salary !== undefined}
                              helperText={errors.salary}
                            />
                          </Grid>
                        </Grid>

                        <Grid
                          item
                          xl={4}
                          lg={6}
                          xs={12}
                          container
                          sx={{ mb: 1, alignItems: "center" }}
                        >
                          <Grid item xs={12} sx={{ mb: 2 }}>
                            <InputLabel
                              sx={{
                                textAlign: "left",
                                whiteSpace: "normal",
                                lineHeight: "18px",
                              }}
                            >
                              Your Employer Name?*
                            </InputLabel>
                          </Grid>
                          <Grid item xs={12}>
                            <TextField
                              fullWidth
                              name="employer_name"
                              variant="outlined"
                              placeholder="Your Employer Name?"
                              value={formData.employer_name}
                              onChange={handleInputChange}
                              error={errors.employer_name !== undefined}
                              helperText={errors.employer_name}
                            />
                          </Grid>
                        </Grid>
                      </Grid>
                    </>
                  )}

                  <Grid
                    item
                    xs={12}
                    container
                    sx={{ mb: 3, alignItems: "center" }}
                  >
                    <Grid item xs={12} sx={{ mb: 2 }}>
                      <InputLabel
                        sx={{
                          textAlign: "left",
                          whiteSpace: "normal",
                          lineHeight: "18px",
                        }}
                      >
                        Did You Find Work Related To The Training You Received
                        At CodeGirls?*
                      </InputLabel>
                    </Grid>
                    <Grid item xs={12}>
                      <RadioGroup
                        row
                        name="code_girls_training_related_work"
                        defaultValue="first"
                        value={formData.code_girls_training_related_work}
                        onChange={handleInputChange}
                      >
                        <MyFormControlLabel
                          value="Yes"
                          label="Yes"
                          control={<Radio />}
                        />
                        <MyFormControlLabel
                          value="No"
                          label="No"
                          control={<Radio />}
                        />
                        <MyFormControlLabel
                          value="Other"
                          label="Other"
                          control={<Radio />}
                        />
                      </RadioGroup>
                    </Grid>
                    {errors.code_girls_training_related_work && (
                      <FormHelperText error>
                        {errors.code_girls_training_related_work}
                      </FormHelperText>
                    )}
                  </Grid>
                  {formData.code_girls_training_related_work === "Other" && (
                    <Grid
                      item
                      xs={12}
                      container
                      sx={{ mb: 3, alignItems: "center" }}
                    >
                      <Grid item xs={12} sx={{ mb: 2 }}>
                        <InputLabel
                          sx={{
                            textAlign: "left",
                            whiteSpace: "normal",
                            lineHeight: "18px",
                          }}
                        >
                          Other*
                        </InputLabel>
                      </Grid>
                      <Grid item xs={12}>
                        <TextField
                          fullWidth
                          name="code_girls_training_related_work_other"
                          variant="outlined"
                          placeholder="Please Give Your Tech Training Details"
                          value={
                            formData.code_girls_training_related_work_other
                          }
                          onChange={handleInputChange}
                          error={
                            errors.code_girls_training_related_work_other !==
                            undefined
                          }
                          helperText={
                            errors.code_girls_training_related_work_other
                          }
                        />
                      </Grid>
                    </Grid>
                  )}
                  <Grid
                    item
                    xs={12}
                    container
                    sx={{ mb: 3, alignItems: "center" }}
                  >
                    <Grid item xs={12} sx={{ mb: 2 }}>
                      <InputLabel
                        sx={{
                          textAlign: "left",
                          whiteSpace: "normal",
                          lineHeight: "18px",
                        }}
                      >
                        Would You Be Interested In Doing An Internship/Job
                        Offered By One Of Our Partners?*
                      </InputLabel>
                    </Grid>
                    <Grid item xs={12}>
                      <RadioGroup
                        row
                        name="interested_in_partner_opportunity"
                        defaultValue="first"
                        value={formData.interested_in_partner_opportunity}
                        onChange={handleInputChange}
                      >
                        <MyFormControlLabel
                          value="Yes"
                          label="Yes"
                          control={<Radio />}
                        />
                        <MyFormControlLabel
                          value="No"
                          label="No"
                          control={<Radio />}
                        />
                        <MyFormControlLabel
                          value="Other"
                          label="Other"
                          control={<Radio />}
                        />
                      </RadioGroup>
                    </Grid>
                    {errors.interested_in_partner_opportunity && (
                      <FormHelperText error>
                        {errors.interested_in_partner_opportunity}
                      </FormHelperText>
                    )}
                  </Grid>
                  {formData.interested_in_partner_opportunity === "Other" && (
                    <Grid
                      item
                      xs={12}
                      container
                      sx={{ mb: 3, alignItems: "center" }}
                    >
                      <Grid item xs={12} sx={{ mb: 2 }}>
                        <InputLabel
                          sx={{
                            textAlign: "left",
                            whiteSpace: "normal",
                            lineHeight: "18px",
                          }}
                        >
                          Other*
                        </InputLabel>
                      </Grid>
                      <Grid item xs={12}>
                        <TextField
                          fullWidth
                          name="interested_in_partner_opportunity_other"
                          variant="outlined"
                          placeholder="Please Give Your Tech Training Details"
                          value={
                            formData.interested_in_partner_opportunity_other
                          }
                          onChange={handleInputChange}
                          error={
                            errors.interested_in_partner_opportunity_other !==
                            undefined
                          }
                          helperText={
                            errors.interested_in_partner_opportunity_other
                          }
                        />
                      </Grid>
                    </Grid>
                  )}
                  {formData.interested_in_partner_opportunity === "Yes" && (
                    <Grid
                      item
                      xs={12}
                      container
                      sx={{ mb: 3, alignItems: "center" }}
                    >
                      <Grid item xs={12} sx={{ mb: 2 }}>
                        <InputLabel
                          sx={{
                            textAlign: "left",
                            whiteSpace: "normal",
                            lineHeight: "18px",
                          }}
                        >
                          What Will You Prefer?*
                        </InputLabel>
                      </Grid>
                      <Grid item xs={12}>
                        <RadioGroup
                          name="opportunity_preference"
                          defaultValue="first"
                          value={formData.opportunity_preference}
                          onChange={handleInputChange}
                        >
                          <MyFormControlLabel
                            value="A Full-Time Office Job"
                            label="A Full-Time Office Job"
                            control={<Radio />}
                          />
                          <MyFormControlLabel
                            value="A Part-Time Office Job"
                            label="A Part-Time Office Job"
                            control={<Radio />}
                          />
                          <MyFormControlLabel
                            value="A Full-Time Remote Job"
                            label="A Full-Time Remote Job"
                            control={<Radio />}
                          />
                          <MyFormControlLabel
                            value="A Part-Time Remote Job"
                            label="A Part-Time Remote Job"
                            control={<Radio />}
                          />
                        </RadioGroup>
                      </Grid>
                      {errors.opportunity_preference && (
                        <FormHelperText error>
                          {errors.opportunity_preference}
                        </FormHelperText>
                      )}
                    </Grid>
                  )}

                  <Grid
                    item
                    xs={12}
                    container
                    sx={{ mb: 3, alignItems: "center" }}
                  >
                    <Grid item xs={12} sx={{ mb: 2 }}>
                      <InputLabel
                        sx={{
                          textAlign: "left",
                          whiteSpace: "normal",
                          lineHeight: "18px",
                        }}
                      >
                        Would You Be Interested In Doing An Advanced Phase Of
                        CodeGirls?*
                      </InputLabel>
                    </Grid>
                    <Grid item xs={12}>
                      <RadioGroup
                        row
                        name="interested_in_advanced_phase"
                        defaultValue="first"
                        value={formData.interested_in_advanced_phase}
                        onChange={handleInputChange}
                      >
                        <MyFormControlLabel
                          value="Yes"
                          label="Yes"
                          control={<Radio />}
                        />
                        <MyFormControlLabel
                          value="No"
                          label="No"
                          control={<Radio />}
                        />
                        <MyFormControlLabel
                          value="Other"
                          label="Other"
                          control={<Radio />}
                        />
                      </RadioGroup>
                    </Grid>
                    {errors.interested_in_advanced_phase && (
                      <FormHelperText error>
                        {errors.interested_in_advanced_phase}
                      </FormHelperText>
                    )}
                  </Grid>
                  {formData.interested_in_advanced_phase === "Other" && (
                    <Grid
                      item
                      xs={12}
                      container
                      sx={{ mb: 3, alignItems: "center" }}
                    >
                      <Grid item xs={12} sx={{ mb: 2 }}>
                        <InputLabel
                          sx={{
                            textAlign: "left",
                            whiteSpace: "normal",
                            lineHeight: "18px",
                          }}
                        >
                          Other*
                        </InputLabel>
                      </Grid>
                      <Grid item xs={12}>
                        <TextField
                          fullWidth
                          name="interested_in_advanced_phase_other"
                          variant="outlined"
                          placeholder="Please Give Your Tech Training Details"
                          value={formData.interested_in_advanced_phase_other}
                          onChange={handleInputChange}
                          error={
                            errors.interested_in_advanced_phase_other !==
                            undefined
                          }
                          helperText={errors.interested_in_advanced_phase_other}
                        />
                      </Grid>
                    </Grid>
                  )}
                  <Grid
                    item
                    xs={12}
                    container
                    sx={{ mb: 3, alignItems: "center" }}
                  >
                    <Grid item xs={12} sx={{ mb: 2 }}>
                      <InputLabel
                        sx={{
                          textAlign: "left",
                          whiteSpace: "normal",
                          lineHeight: "18px",
                        }}
                      >
                        Do you recommend ConsulNet Corporation to other people?*
                      </InputLabel>
                    </Grid>
                    <Grid item xs={12}>
                      <RadioGroup
                        row
                        name="recommend_consulnet"
                        defaultValue="first"
                        value={formData.recommend_consulnet}
                        onChange={handleInputChange}
                      >
                        <MyFormControlLabel
                          value="Yes"
                          label="Yes"
                          control={<Radio />}
                        />
                        <MyFormControlLabel
                          value="No"
                          label="No"
                          control={<Radio />}
                        />
                      </RadioGroup>
                    </Grid>
                    {errors.recommend_consulnet && (
                      <FormHelperText error>
                        {errors.recommend_consulnet}
                      </FormHelperText>
                    )}
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    container
                    sx={{ mb: 3, alignItems: "center" }}
                  >
                    <Grid item xs={12} sx={{ mb: 2 }}>
                      <InputLabel
                        sx={{
                          textAlign: "left",
                          whiteSpace: "normal",
                          lineHeight: "18px",
                        }}
                      >
                        Would You Be Interested In Attending The Networking
                        Events/Seminars/Lectures/Workshops Hosted By ConsulNet
                        And/Or WomenInTechPK?*
                      </InputLabel>
                    </Grid>
                    <Grid item xs={12}>
                      <RadioGroup
                        row
                        name="interested_in_events"
                        defaultValue="first"
                        value={formData.interested_in_events}
                        onChange={handleInputChange}
                      >
                        <MyFormControlLabel
                          value="Yes"
                          label="Yes"
                          control={<Radio />}
                        />
                        <MyFormControlLabel
                          value="No"
                          label="No"
                          control={<Radio />}
                        />
                        <MyFormControlLabel
                          value="Other"
                          label="Other"
                          control={<Radio />}
                        />
                      </RadioGroup>
                    </Grid>
                    {errors.interested_in_events && (
                      <FormHelperText error>
                        {errors.interested_in_events}
                      </FormHelperText>
                    )}
                  </Grid>
                  {formData.interested_in_events === "Other" && (
                    <Grid
                      item
                      xs={12}
                      container
                      sx={{ mb: 3, alignItems: "center" }}
                    >
                      <Grid item xs={12} sx={{ mb: 2 }}>
                        <InputLabel
                          sx={{
                            textAlign: "left",
                            whiteSpace: "normal",
                            lineHeight: "18px",
                          }}
                        >
                          Other*
                        </InputLabel>
                      </Grid>
                      <Grid item xs={12}>
                        <TextField
                          fullWidth
                          name="interested_in_events_other"
                          variant="outlined"
                          placeholder="Please Give Your Tech Training Details"
                          value={formData.interested_in_events_other}
                          onChange={handleInputChange}
                          error={
                            errors.interested_in_events_other !== undefined
                          }
                          helperText={errors.interested_in_events_other}
                        />
                      </Grid>
                    </Grid>
                  )}
                  <Grid
                    item
                    xs={12}
                    container
                    sx={{ mb: 3, alignItems: "center" }}
                  >
                    <Grid item xs={12} sx={{ mb: 2 }}>
                      <InputLabel
                        sx={{
                          textAlign: "left",
                          whiteSpace: "normal",
                          lineHeight: "18px",
                        }}
                      >
                        Would You Prefer Freelancing Over A Full-Time/Part-Time
                        Job?*
                      </InputLabel>
                    </Grid>
                    <Grid item xs={12}>
                      <RadioGroup
                        row
                        name="prefer_freelancing"
                        defaultValue="first"
                        value={formData.prefer_freelancing}
                        onChange={handleInputChange}
                      >
                        <MyFormControlLabel
                          value="Yes"
                          label="Yes"
                          control={<Radio />}
                        />
                        <MyFormControlLabel
                          value="No"
                          label="No"
                          control={<Radio />}
                        />
                        <MyFormControlLabel
                          value="Other"
                          label="Other"
                          control={<Radio />}
                        />
                      </RadioGroup>
                    </Grid>
                    {errors.prefer_freelancing && (
                      <FormHelperText error>
                        {errors.prefer_freelancing}
                      </FormHelperText>
                    )}
                  </Grid>
                  {formData.prefer_freelancing === "Other" && (
                    <Grid
                      item
                      xs={12}
                      container
                      sx={{ mb: 3, alignItems: "center" }}
                    >
                      <Grid item xs={12} sx={{ mb: 2 }}>
                        <InputLabel
                          sx={{
                            textAlign: "left",
                            whiteSpace: "normal",
                            lineHeight: "18px",
                          }}
                        >
                          Other*
                        </InputLabel>
                      </Grid>
                      <Grid item xs={12}>
                        <TextField
                          fullWidth
                          name="prefer_freelancing_other"
                          variant="outlined"
                          placeholder="Please Give Your Tech Training Details"
                          value={formData.prefer_freelancing_other}
                          onChange={handleInputChange}
                          error={errors.prefer_freelancing_other !== undefined}
                          helperText={errors.prefer_freelancing_other}
                        />
                      </Grid>
                    </Grid>
                  )}

                  {/* New Post-Assessment Fields */}
                  <Grid
                    item
                    xs={12}
                    container
                    sx={{ mb: 3, alignItems: "center" }}
                  >
                    <Grid item xs={12} sx={{ mb: 2 }}>
                      <InputLabel
                        sx={{
                          textAlign: "left",
                          whiteSpace: "normal",
                          lineHeight: "18px",
                        }}
                      >
                        Did you achieve your objectives by joining the training?*
                      </InputLabel>
                    </Grid>
                    <Grid item xs={12}>
                      <RadioGroup
                        row
                        name="training_objective_achieved"
                        defaultValue="first"
                        value={formData.training_objective_achieved}
                        onChange={handleInputChange}
                      >
                        <MyFormControlLabel
                          value="Yes"
                          label="Yes"
                          control={<Radio />}
                        />
                        <MyFormControlLabel
                          value="No"
                          label="No"
                          control={<Radio />}
                        />
                        <MyFormControlLabel
                          value="Somewhat"
                          label="Somewhat"
                          control={<Radio />}
                        />
                      </RadioGroup>
                    </Grid>
                    {errors.training_objective_achieved && (
                      <FormHelperText error>
                        {errors.training_objective_achieved}
                      </FormHelperText>
                    )}
                  </Grid>

                  <Grid
                    item
                    xs={12}
                    container
                    sx={{ mb: 3, alignItems: "center" }}
                  >
                    <Grid item xs={12} sx={{ mb: 2 }}>
                      <InputLabel
                        sx={{
                          textAlign: "left",
                          whiteSpace: "normal",
                          lineHeight: "18px",
                        }}
                      >
                        What was the impact of training on your personal life? (select all that apply)*
                      </InputLabel>
                    </Grid>
                    <Grid item xs={12}>
                      {[
                        "Improved confidence",
                        "I feel more empowered",
                        "I gained financial independence",
                        "I am more hopeful about the future",
                        "I have gained direction for my career",
                        "No impact",
                      ].map((item, index) => {
                        return (
                          <FormControlLabel
                            key={index}
                            control={
                              <Checkbox
                                checked={formData.training_impact_personal_life.includes(
                                  item
                                )}
                                onChange={() => handleCheckboxChange('training_impact_personal_life', item)}
                                name="training_impact_personal_life"
                              />
                            }
                            label={item}
                          />
                        );
                      })}
                    </Grid>
                    {errors.training_impact_personal_life && (
                      <FormHelperText error>
                        {errors.training_impact_personal_life}
                      </FormHelperText>
                    )}
                  </Grid>

                  <Grid
                    item
                    xs={12}
                    container
                    sx={{ mb: 3, alignItems: "center" }}
                  >
                    <Grid item xs={12} sx={{ mb: 2 }}>
                      <InputLabel
                        sx={{
                          textAlign: "left",
                          whiteSpace: "normal",
                          lineHeight: "18px",
                        }}
                      >
                        What did you do after graduating from the training?*
                      </InputLabel>
                    </Grid>
                    <Grid item xs={12}>
                      <TextField
                        fullWidth
                        name="post_training_activity"
                        variant="outlined"
                        placeholder="Select your activity after training"
                        value={formData.post_training_activity}
                        onChange={handleInputChange}
                        error={errors.post_training_activity !== undefined}
                        helperText={errors.post_training_activity}
                        select
                      >
                        {[
                          "Job in tech industry",
                          "Internship in tech industry",
                          "Job in other sector",
                          "Promotion",
                          "Enrolled in other advanced training",
                          "Taught others",
                          "I am completing my education",
                          "Other",
                        ].map((option) => (
                          <MenuItem key={option} value={option}>
                            {option}
                          </MenuItem>
                        ))}
                      </TextField>
                    </Grid>
                  </Grid>

                  {formData.post_training_activity === "Other" && (
                    <Grid
                      item
                      xs={12}
                      container
                      sx={{ mb: 3, alignItems: "center" }}
                    >
                      <Grid item xs={12} sx={{ mb: 2 }}>
                        <InputLabel
                          sx={{
                            textAlign: "left",
                            whiteSpace: "normal",
                            lineHeight: "18px",
                          }}
                        >
                          Please specify other activity*
                        </InputLabel>
                      </Grid>
                      <Grid item xs={12}>
                        <TextField
                          fullWidth
                          name="post_training_activity_other"
                          variant="outlined"
                          placeholder="Please specify other activity"
                          value={formData.post_training_activity_other}
                          onChange={handleInputChange}
                          error={errors.post_training_activity_other !== undefined}
                          helperText={errors.post_training_activity_other}
                        />
                      </Grid>
                    </Grid>
                  )}

                  <Grid
                    item
                    xs={12}
                    container
                    sx={{ mb: 3, alignItems: "center" }}
                  >
                    <Grid item xs={12} sx={{ mb: 2 }}>
                      <InputLabel
                        sx={{
                          textAlign: "left",
                          whiteSpace: "normal",
                          lineHeight: "18px",
                        }}
                      >
                        What do you plan to do in the future?*
                      </InputLabel>
                    </Grid>
                    <Grid item xs={12}>
                      <TextField
                        fullWidth
                        name="future_plans"
                        variant="outlined"
                        placeholder="Select your future plans"
                        value={formData.future_plans}
                        onChange={handleInputChange}
                        error={errors.future_plans !== undefined}
                        helperText={errors.future_plans}
                        select
                      >
                        {[
                          "Stay in tech",
                          "Find tech job",
                          "Learn more tech",
                          "Switch away from tech",
                        ].map((option) => (
                          <MenuItem key={option} value={option}>
                            {option}
                          </MenuItem>
                        ))}
                      </TextField>
                    </Grid>
                  </Grid>

                  <Grid
                    item
                    xs={12}
                    container
                    sx={{ mb: 3, alignItems: "center" }}
                  >
                    <Grid item xs={12} sx={{ mb: 2 }}>
                      <InputLabel
                        sx={{
                          textAlign: "left",
                          whiteSpace: "normal",
                          lineHeight: "18px",
                        }}
                      >
                        Have you ever been employed/freelanced/run a business?*
                      </InputLabel>
                    </Grid>
                    <Grid item xs={12}>
                      <TextField
                        fullWidth
                        name="employment_status"
                        variant="outlined"
                        placeholder="Select your employment status"
                        value={formData.employment_status}
                        onChange={handleInputChange}
                        error={errors.employment_status !== undefined}
                        helperText={errors.employment_status}
                        select
                      >
                        {[
                          "I am employed",
                          "I am a freelancer",
                          "I own a business",
                          "I am unemployed",
                        ].map((option) => (
                          <MenuItem key={option} value={option}>
                            {option}
                          </MenuItem>
                        ))}
                      </TextField>
                    </Grid>
                  </Grid>

                  {formData.employment_status === "I am unemployed" && (
                    <>
                      <Grid
                        item
                        xs={12}
                        container
                        sx={{ mb: 3, alignItems: "center" }}
                      >
                        <Grid item xs={12} sx={{ mb: 2 }}>
                          <InputLabel
                            sx={{
                              textAlign: "left",
                              whiteSpace: "normal",
                              lineHeight: "18px",
                            }}
                          >
                            Reason(s) for not working (select all that apply)*
                          </InputLabel>
                        </Grid>
                        <Grid item xs={12}>
                          {[
                            "Full-time student",
                            "I have to care for kids/elderly at home",
                            "Permission issues",
                            "Health issues",
                            "I regularly apply but fail in the test/interview",
                            "I want a remote job",
                            "I am not confident that I can do a job",
                            "I don't want to work",
                          ].map((item, index) => {
                            return (
                              <FormControlLabel
                                key={index}
                                control={
                                  <Checkbox
                                    checked={formData.unemployment_reasons.includes(
                                      item
                                    )}
                                    onChange={() => handleCheckboxChange('unemployment_reasons', item)}
                                    name="unemployment_reasons"
                                  />
                                }
                                label={item}
                              />
                            );
                          })}
                        </Grid>
                        {errors.unemployment_reasons && (
                          <FormHelperText error>
                            {errors.unemployment_reasons}
                          </FormHelperText>
                        )}
                      </Grid>
                    </>
                  )}

                  {formData.employment_status === "I am employed" && (
                    <>
                      <Grid container spacing={2}>
                        <Grid
                          item
                          xl={4}
                          lg={6}
                          xs={12}
                          container
                          sx={{ mb: 1, alignItems: "center" }}
                        >
                          <Grid item xs={12} sx={{ mb: 2 }}>
                            <InputLabel
                              sx={{
                                textAlign: "left",
                                whiteSpace: "normal",
                                lineHeight: "18px",
                              }}
                            >
                              Number of jobs since completing the training*
                            </InputLabel>
                          </Grid>
                          <Grid item xs={12}>
                            <TextField
                              fullWidth
                              name="number_of_jobs"
                              variant="outlined"
                              placeholder="Number of jobs"
                              value={formData.number_of_jobs}
                              onChange={handleInputChangeNumber}
                              error={errors.number_of_jobs !== undefined}
                              helperText={errors.number_of_jobs}
                              type="number"
                            />
                          </Grid>
                        </Grid>

                        <Grid
                          item
                          xl={4}
                          lg={6}
                          xs={12}
                          container
                          sx={{ mb: 1, alignItems: "center" }}
                        >
                          <Grid item xs={12} sx={{ mb: 2 }}>
                            <InputLabel
                              sx={{
                                textAlign: "left",
                                whiteSpace: "normal",
                                lineHeight: "18px",
                              }}
                            >
                              Relevance of employment to skills learnt at ConsulNet*
                            </InputLabel>
                          </Grid>
                          <Grid item xs={12}>
                            <TextField
                              fullWidth
                              name="employment_relevance"
                              variant="outlined"
                              placeholder="Select relevance"
                              value={formData.employment_relevance}
                              onChange={handleInputChange}
                              error={errors.employment_relevance !== undefined}
                              helperText={errors.employment_relevance}
                              select
                            >
                              {[
                                "Very",
                                "Somewhat",
                                "Not Relevant",
                              ].map((option) => (
                                <MenuItem key={option} value={option}>
                                  {option}
                                </MenuItem>
                              ))}
                            </TextField>
                          </Grid>
                        </Grid>

                        <Grid
                          item
                          xl={4}
                          lg={6}
                          xs={12}
                          container
                          sx={{ mb: 1, alignItems: "center" }}
                        >
                          <Grid item xs={12} sx={{ mb: 2 }}>
                            <InputLabel
                              sx={{
                                textAlign: "left",
                                whiteSpace: "normal",
                                lineHeight: "18px",
                              }}
                            >
                              Total years of professional experience*
                            </InputLabel>
                          </Grid>
                          <Grid item xs={12}>
                            <TextField
                              fullWidth
                              name="total_experience_years"
                              variant="outlined"
                              placeholder="Total years of experience"
                              value={formData.total_experience_years}
                              onChange={handleInputChangeNumber}
                              error={errors.total_experience_years !== undefined}
                              helperText={errors.total_experience_years}
                              type="number"
                            />
                          </Grid>
                        </Grid>

                        <Grid
                          item
                          xl={4}
                          lg={6}
                          xs={12}
                          container
                          sx={{ mb: 1, alignItems: "center" }}
                        >
                          <Grid item xs={12} sx={{ mb: 2 }}>
                            <InputLabel
                              sx={{
                                textAlign: "left",
                                whiteSpace: "normal",
                                lineHeight: "18px",
                              }}
                            >
                              Years of experience in tech industry*
                            </InputLabel>
                          </Grid>
                          <Grid item xs={12}>
                            <TextField
                              fullWidth
                              name="tech_experience_years"
                              variant="outlined"
                              placeholder="Years of tech experience"
                              value={formData.tech_experience_years}
                              onChange={handleInputChangeNumber}
                              error={errors.tech_experience_years !== undefined}
                              helperText={errors.tech_experience_years}
                              type="number"
                            />
                          </Grid>
                        </Grid>
                      </Grid>

                      <Grid
                        item
                        xs={12}
                        container
                        sx={{ mb: 3, alignItems: "center" }}
                      >
                        <Grid item xs={12} sx={{ mb: 2 }}>
                          <InputLabel
                            sx={{
                              textAlign: "left",
                              whiteSpace: "normal",
                              lineHeight: "18px",
                            }}
                          >
                            I would have had a career without the training too.*
                          </InputLabel>
                        </Grid>
                        <Grid item xs={12}>
                          <RadioGroup
                            row
                            name="career_without_training"
                            defaultValue="first"
                            value={formData.career_without_training}
                            onChange={handleInputChange}
                          >
                            <MyFormControlLabel
                              value="Likely"
                              label="Likely"
                              control={<Radio />}
                            />
                            <MyFormControlLabel
                              value="Neutral"
                              label="Neutral"
                              control={<Radio />}
                            />
                            <MyFormControlLabel
                              value="Not Likely"
                              label="Not Likely"
                              control={<Radio />}
                            />
                          </RadioGroup>
                        </Grid>
                        {errors.career_without_training && (
                          <FormHelperText error>
                            {errors.career_without_training}
                          </FormHelperText>
                        )}
                      </Grid>

                      <Grid
                        item
                        xs={12}
                        container
                        sx={{ mb: 3, alignItems: "center" }}
                      >
                        <Grid item xs={12} sx={{ mb: 2 }}>
                          <InputLabel
                            sx={{
                              textAlign: "left",
                              whiteSpace: "normal",
                              lineHeight: "18px",
                            }}
                          >
                            Is your current pay better than before you got the training?*
                          </InputLabel>
                        </Grid>
                        <Grid item xs={12}>
                          <RadioGroup
                            row
                            name="pay_better_than_before"
                            defaultValue="first"
                            value={formData.pay_better_than_before}
                            onChange={handleInputChange}
                          >
                            <MyFormControlLabel
                              value="Yes"
                              label="Yes"
                              control={<Radio />}
                            />
                            <MyFormControlLabel
                              value="No"
                              label="No"
                              control={<Radio />}
                            />
                          </RadioGroup>
                        </Grid>
                        {errors.pay_better_than_before && (
                          <FormHelperText error>
                            {errors.pay_better_than_before}
                          </FormHelperText>
                        )}
                      </Grid>

                      {formData.pay_better_than_before === "Yes" && (
                        <Grid
                          item
                          xs={12}
                          container
                          sx={{ mb: 3, alignItems: "center" }}
                        >
                          <Grid item xs={12} sx={{ mb: 2 }}>
                            <InputLabel
                              sx={{
                                textAlign: "left",
                                whiteSpace: "normal",
                                lineHeight: "18px",
                              }}
                            >
                              Do you think it is because of the training?*
                            </InputLabel>
                          </Grid>
                          <Grid item xs={12}>
                            <TextField
                              fullWidth
                              name="pay_better_reason"
                              variant="outlined"
                              placeholder="Please explain"
                              value={formData.pay_better_reason}
                              onChange={handleInputChange}
                              error={errors.pay_better_reason !== undefined}
                              helperText={errors.pay_better_reason}
                            />
                          </Grid>
                        </Grid>
                      )}
                    </>
                  )}

                  {formData.employment_status === "I am a freelancer" && (
                    <>
                      <Grid
                        item
                        xs={12}
                        container
                        sx={{ mb: 3, alignItems: "center" }}
                      >
                        <Grid item xs={12} sx={{ mb: 2 }}>
                          <InputLabel
                            sx={{
                              textAlign: "left",
                              whiteSpace: "normal",
                              lineHeight: "18px",
                            }}
                          >
                            Platforms used*
                          </InputLabel>
                        </Grid>
                        <Grid item xs={12}>
                          <TextField
                            fullWidth
                            name="freelancing_platforms"
                            variant="outlined"
                            placeholder="Enter platforms used"
                            value={formData.freelancing_platforms}
                            onChange={handleInputChange}
                            error={errors.freelancing_platforms !== undefined}
                            helperText={errors.freelancing_platforms}
                          />
                        </Grid>
                      </Grid>

                      <Grid
                        item
                        xs={12}
                        container
                        sx={{ mb: 3, alignItems: "center" }}
                      >
                        <Grid item xs={12} sx={{ mb: 2 }}>
                          <InputLabel
                            sx={{
                              textAlign: "left",
                              whiteSpace: "normal",
                              lineHeight: "18px",
                            }}
                          >
                            Share links of Projects completed*
                          </InputLabel>
                        </Grid>
                        <Grid item xs={12}>
                          <TextField
                            fullWidth
                            name="freelancing_projects"
                            variant="outlined"
                            placeholder="Enter project links"
                            value={formData.freelancing_projects}
                            onChange={handleInputChange}
                            error={errors.freelancing_projects !== undefined}
                            helperText={errors.freelancing_projects}
                          />
                        </Grid>
                      </Grid>

                      <Grid
                        item
                        xs={12}
                        container
                        sx={{ mb: 3, alignItems: "center" }}
                      >
                        <Grid item xs={12} sx={{ mb: 2 }}>
                          <InputLabel
                            sx={{
                              textAlign: "left",
                              whiteSpace: "normal",
                              lineHeight: "18px",
                            }}
                          >
                            Average monthly income*
                          </InputLabel>
                        </Grid>
                        <Grid item xs={12}>
                          <TextField
                            fullWidth
                            name="freelancing_income"
                            variant="outlined"
                            placeholder="Enter average monthly income"
                            value={formData.freelancing_income}
                            onChange={handleInputChange}
                            error={errors.freelancing_income !== undefined}
                            helperText={errors.freelancing_income}
                          />
                        </Grid>
                      </Grid>

                      <Grid
                        item
                        xs={12}
                        container
                        sx={{ mb: 3, alignItems: "center" }}
                      >
                        <Grid item xs={12} sx={{ mb: 2 }}>
                          <InputLabel
                            sx={{
                              textAlign: "left",
                              whiteSpace: "normal",
                              lineHeight: "18px",
                            }}
                          >
                            Technologies used*
                          </InputLabel>
                        </Grid>
                        <Grid item xs={12}>
                          <TextField
                            fullWidth
                            name="freelancing_technologies"
                            variant="outlined"
                            placeholder="Enter technologies used"
                            value={formData.freelancing_technologies}
                            onChange={handleInputChange}
                            error={errors.freelancing_technologies !== undefined}
                            helperText={errors.freelancing_technologies}
                          />
                        </Grid>
                      </Grid>

                      <Grid
                        item
                        xs={12}
                        container
                        sx={{ mb: 3, alignItems: "center" }}
                      >
                        <Grid item xs={12} sx={{ mb: 2 }}>
                          <InputLabel
                            sx={{
                              textAlign: "left",
                              whiteSpace: "normal",
                              lineHeight: "18px",
                            }}
                          >
                            Did your training at ConsulNet help in freelancing journey?*
                          </InputLabel>
                        </Grid>
                        <Grid item xs={12}>
                          <TextField
                            fullWidth
                            name="freelancing_help_from_training"
                            variant="outlined"
                            placeholder="Please explain how training helped"
                            value={formData.freelancing_help_from_training}
                            onChange={handleInputChange}
                            error={errors.freelancing_help_from_training !== undefined}
                            helperText={errors.freelancing_help_from_training}
                          />
                        </Grid>
                      </Grid>
                    </>
                  )}

                  {formData.employment_status === "I own a business" && (
                    <>
                      <Grid
                        item
                        xs={12}
                        container
                        sx={{ mb: 3, alignItems: "center" }}
                      >
                        <Grid item xs={12} sx={{ mb: 2 }}>
                          <InputLabel
                            sx={{
                              textAlign: "left",
                              whiteSpace: "normal",
                              lineHeight: "18px",
                            }}
                          >
                            Business Name*
                          </InputLabel>
                        </Grid>
                        <Grid item xs={12}>
                          <TextField
                            fullWidth
                            name="business_name"
                            variant="outlined"
                            placeholder="Enter business name"
                            value={formData.business_name}
                            onChange={handleInputChange}
                            error={errors.business_name !== undefined}
                            helperText={errors.business_name}
                          />
                        </Grid>
                      </Grid>

                      <Grid
                        item
                        xs={12}
                        container
                        sx={{ mb: 3, alignItems: "center" }}
                      >
                        <Grid item xs={12} sx={{ mb: 2 }}>
                          <InputLabel
                            sx={{
                              textAlign: "left",
                              whiteSpace: "normal",
                              lineHeight: "18px",
                            }}
                          >
                            Nature of business*
                          </InputLabel>
                        </Grid>
                        <Grid item xs={12}>
                          <TextField
                            fullWidth
                            name="business_nature"
                            variant="outlined"
                            placeholder="Enter nature of business"
                            value={formData.business_nature}
                            onChange={handleInputChange}
                            error={errors.business_nature !== undefined}
                            helperText={errors.business_nature}
                          />
                        </Grid>
                      </Grid>

                      <Grid
                        item
                        xs={12}
                        container
                        sx={{ mb: 3, alignItems: "center" }}
                      >
                        <Grid item xs={12} sx={{ mb: 2 }}>
                          <InputLabel
                            sx={{
                              textAlign: "left",
                              whiteSpace: "normal",
                              lineHeight: "18px",
                            }}
                          >
                            Sales platforms used*
                          </InputLabel>
                        </Grid>
                        <Grid item xs={12}>
                          <TextField
                            fullWidth
                            name="business_sales_platforms"
                            variant="outlined"
                            placeholder="Enter sales platforms used"
                            value={formData.business_sales_platforms}
                            onChange={handleInputChange}
                            error={errors.business_sales_platforms !== undefined}
                            helperText={errors.business_sales_platforms}
                          />
                        </Grid>
                      </Grid>

                      <Grid
                        item
                        xs={12}
                        container
                        sx={{ mb: 3, alignItems: "center" }}
                      >
                        <Grid item xs={12} sx={{ mb: 2 }}>
                          <InputLabel
                            sx={{
                              textAlign: "left",
                              whiteSpace: "normal",
                              lineHeight: "18px",
                            }}
                          >
                            Tech-enabled?*
                          </InputLabel>
                        </Grid>
                        <Grid item xs={12}>
                          <RadioGroup
                            row
                            name="business_tech_enabled"
                            defaultValue="first"
                            value={formData.business_tech_enabled}
                            onChange={handleInputChange}
                          >
                            <MyFormControlLabel
                              value="Yes"
                              label="Yes"
                              control={<Radio />}
                            />
                            <MyFormControlLabel
                              value="No"
                              label="No"
                              control={<Radio />}
                            />
                          </RadioGroup>
                        </Grid>
                        {errors.business_tech_enabled && (
                          <FormHelperText error>
                            {errors.business_tech_enabled}
                          </FormHelperText>
                        )}
                      </Grid>

                      <Grid
                        item
                        xs={12}
                        container
                        sx={{ mb: 3, alignItems: "center" }}
                      >
                        <Grid item xs={12} sx={{ mb: 2 }}>
                          <InputLabel
                            sx={{
                              textAlign: "left",
                              whiteSpace: "normal",
                              lineHeight: "18px",
                            }}
                          >
                            Duration (years)*
                          </InputLabel>
                        </Grid>
                        <Grid item xs={12}>
                          <TextField
                            fullWidth
                            name="business_duration"
                            variant="outlined"
                            placeholder="Enter business duration in years"
                            value={formData.business_duration}
                            onChange={handleInputChangeNumber}
                            error={errors.business_duration !== undefined}
                            helperText={errors.business_duration}
                            type="number"
                          />
                        </Grid>
                      </Grid>

                      <Grid
                        item
                        xs={12}
                        container
                        sx={{ mb: 3, alignItems: "center" }}
                      >
                        <Grid item xs={12} sx={{ mb: 2 }}>
                          <InputLabel
                            sx={{
                              textAlign: "left",
                              whiteSpace: "normal",
                              lineHeight: "18px",
                            }}
                          >
                            Monthly revenue*
                          </InputLabel>
                        </Grid>
                        <Grid item xs={12}>
                          <TextField
                            fullWidth
                            name="business_monthly_revenue"
                            variant="outlined"
                            placeholder="Enter monthly revenue"
                            value={formData.business_monthly_revenue}
                            onChange={handleInputChange}
                            error={errors.business_monthly_revenue !== undefined}
                            helperText={errors.business_monthly_revenue}
                          />
                        </Grid>
                      </Grid>
                    </>
                  )}

                  <Grid
                    item
                    xs={12}
                    container
                    sx={{ mb: 3, alignItems: "center" }}
                  >
                    <Grid item xs={12} sx={{ mb: 2 }}>
                      <InputLabel
                        sx={{
                          textAlign: "left",
                          whiteSpace: "normal",
                          lineHeight: "18px",
                        }}
                      >
                        Would you like your journey to be featured?*
                      </InputLabel>
                    </Grid>
                    <Grid item xs={12}>
                      <TextField
                        fullWidth
                        name="engagement_feature_journey"
                        variant="outlined"
                        placeholder="Select your preference"
                        value={formData.engagement_feature_journey}
                        onChange={handleInputChange}
                        error={errors.engagement_feature_journey !== undefined}
                        helperText={errors.engagement_feature_journey}
                        select
                      >
                        {[
                          "Written",
                          "Written+Video",
                          "No",
                        ].map((option) => (
                          <MenuItem key={option} value={option}>
                            {option}
                          </MenuItem>
                        ))}
                      </TextField>
                    </Grid>
                  </Grid>

                  <Grid
                    item
                    xs={12}
                    container
                    sx={{ mb: 3, alignItems: "center" }}
                  >
                    <Grid item xs={12} sx={{ mb: 2 }}>
                      <InputLabel
                        sx={{
                          textAlign: "left",
                          whiteSpace: "normal",
                          lineHeight: "18px",
                        }}
                      >
                        Would you like to engage with the CodeGirls community as: (select all that apply)*
                      </InputLabel>
                    </Grid>
                    <Grid item xs={12}>
                      {[
                        "Coding trainer",
                        "Mentor",
                        "Teaching assistant (intern)",
                        "Program office team member",
                        "Speaker",
                        "Alumni meetup participant",
                        "Recruiter / Source of employees",
                      ].map((item, index) => {
                        return (
                          <FormControlLabel
                            key={index}
                            control={
                              <Checkbox
                                checked={formData.engagement_community_roles.includes(
                                  item
                                )}
                                onChange={() => handleCheckboxChange('engagement_community_roles', item)}
                                name="engagement_community_roles"
                              />
                            }
                            label={item}
                          />
                        );
                      })}
                    </Grid>
                    {errors.engagement_community_roles && (
                      <FormHelperText error>
                        {errors.engagement_community_roles}
                      </FormHelperText>
                    )}
                  </Grid>
                </Grid>
              </Grid>
            </Form>
          </Grid>
        </Grid>
      </div>
      <ToastContainer />
    </>
  );
}